import { CUSTOM_QUESTION_TYPES_ID } from "../constants/CustomQuestions.constants";

export const isMultiQuestionType = (questionType: number) => {
  if (!questionType) return false;
  return [
    CUSTOM_QUESTION_TYPES_ID.PAN as number,
    CUSTOM_QUESTION_TYPES_ID.GST,
  ].includes(questionType);
};
